import TextureLayer from './TextureLayer';
import { ImageLayerProps } from '../types/layer';
import ImageLoader from "../utils/ImageLoader";

export default class ImageTextureLayer extends TextureLayer {
  protected image: HTMLImageElement;
  public position: { x: number; y: number; };
  public checkMouse;
  public resizeIconMouse;
  public rotateIconMouse;
  protected size: { dw: number; dh: number; };
  protected scale = 1;
  protected rotation = 0;

  constructor({ image, w, h, dw, dh, x, y, visible, index }: ImageLayerProps) {
    super({ w: w ?? image.width, h: h ?? image.height, visible });
    this.image = image;
    this.position = { x: x ?? 0, y: y ?? 0 };
    this.size = { dw: dw ?? image?.width ?? this.width, dh: dh ?? image?.height ?? this.height };
    this.index = index
  }

  async loadIconsMouse() {
    this.resizeIconMouse = await ImageLoader.promiseLoader(process.env.REACT_APP_PATH + 'icons/resize.svg');
    this.rotateIconMouse = await ImageLoader.promiseLoader(process.env.REACT_APP_PATH + 'icons/rotate.svg');
  }

  setRotation(deg) {
    this.rotation = deg;
    this.needsRender = true;
  }

  setImage(image) {
    this.image = image;
    this.position = { x: 0, y: 0 };
    this.size.dw = this.width;
    this.size.dh = this.height;
    this.needsRender = true;
  }

  setPositions(position:{x:number,y:number}){
    this.position = position;
    this.needsRender = true;
  }

  updateIndex(value){
    this.index = value;
  }

  render(size, active =false) {
    if (!super.render(size)) return false;
    if(this.checkMouse){
      this.loadIconsMouse();
    }
    const { width, height } = this.getImageSize();

    // Rotation
    this.context.translate(this.position.x + width * 0.5, this.position.y + height * 0.5);
    this.context.rotate(this.rotation);
    this.context.translate(-this.position.x - width * 0.5, -this.position.y - height * 0.5);

    // Image
    this.context.drawImage(this.image, this.position.x, this.position.y, width, height);

    // MouseMat
    if(size === "l" || size === "m"){
      if(active){
        this.context.strokeStyle = "black";
        this.context.lineWidth = 3;
        this.context.setLineDash([16, 16]);
        this.context.strokeRect(this.position.x, this.position.y, width+5, height+5);
        this.context.stroke();
        // Render Icons
        if (this.resizeIconMouse && this.rotateIconMouse) {
          this.context.drawImage(this.resizeIconMouse, this.position.x-20, this.position.y-45, 38, 38);
          this.context.drawImage(this.rotateIconMouse, this.position.x + width-20, this.position.y-45, 38, 38);
        }
      }
    }

    this.context.setTransform(1, 0, 0, 1, 0, 0);

    return true;
  }

  getImageSize(scale = this.scale) {
    return { width: this.size.dw * scale, height: this.size.dh *  scale };
  }

  getPosition() {
    return this.position;
  }

  getScale() {
    return this.scale;
  }

  getRotate() {
    return this.rotation;
  }

  toJSON() {
    return {
      image: this.getCanvas().toDataURL(),
      position: [this.position.x, this.position.y],
      scale: this.scale,
      rotate: this.rotation,
      index: this.index
    };
  }
}
